// テーマ全体に関わるJS処理を記述

// Scroll to Top
function backToTop() {
  const btn = document.querySelector("#scrollTopBtn");
  btn.addEventListener('click', () => {
    window.scroll({ 
      top: 0, 
      behavior: "smooth"
    });
  });
}

window.addEventListener('DOMContentLoaded',function(){
  backToTop();
});